import Vue from 'vue';
import * as Sentry from '@sentry/browser';
import { Integrations } from '@sentry/tracing';

import { SENTRY_OPTIONS } from 'RootDir/common/constants';

export default (app: Vue): void => {
  Sentry.init({
    Vue: app,
    dsn: SENTRY_OPTIONS.dsn,
    autoSessionTracking: true,
    integrations: [
      new Integrations.BrowserTracing(),
    ],
    environment: SENTRY_OPTIONS.environment,
    tracingOptions: {
      trackComponents: SENTRY_OPTIONS.trackComponents,
    },
    tracesSampleRate: SENTRY_OPTIONS.tracesSampleRate,
  } as Sentry.BrowserOptions);
};
